import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ADVANCED_SEARCH_SETTINGS_DEFAULTS } from '../../../../interfaces/advancedSearch.interface';

@Component({
    selector: 'app-advanced-search-date',
    templateUrl: './advanced-search-date.component.html',
    styleUrls: ['./advanced-search-date.component.scss']
})
export class AdvancedSearchDateComponent implements OnInit {

    @Input() control: FormControl;
    @Input() label: string;

    @Input() minDate: NgbDateStruct;
    @Input() maxDate: NgbDateStruct;

    readonly DEFAULTS = ADVANCED_SEARCH_SETTINGS_DEFAULTS;
    private readonly dateFormat = 'YYYY-MM-DD';

    constructor() { }

    ngOnInit(): void { }

    onDateChange(event: { value: NgbDateStruct }) {
        if (event.value) {
            this.control.setValue(this.formatDate(event.value));
            this.control.markAsDirty();
        } else {
            this.control.setValue('');
            this.control.markAsPristine();
        }
    }

    private formatDate(date: NgbDateStruct): string {
        return moment({
            year: date.year,
            month: date.month - 1,
            day: date.day
        }).format(this.dateFormat);
    }
}
